module.exports = "/wwwroot/img/collection_vehicle_schedule_block.png?ver=080fbaf8";